const styles = () => ({
  root: {
    flex: '1 1 auto',
    maxWidth: 570,
    margin: '42px 0px',
    display: 'flex',
    flexDirection: 'column',
  },

  pane: {
    overflow: 'auto',
    marginRight: '34px',
  },

  form: {
    padding: 55,
  },

  input: {
    marginBottom: 25,
  },

  largeInput: {
    fontSize: 22,
  },
});

export default styles;
